export default "__VITE_ASSET__8PmJH4Zu__"